/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 */

export const resolveAssignedGuestSummaries = (
  networkGuestIds = [],
  guestOptions = [],
  fallbackLabel,
) => {
  const guestOptionsById = new Map(
    guestOptions.map((guest) => [guest.value, guest]),
  );

  return networkGuestIds.map((networkGuestId) => ({
    id: networkGuestId,
    label:
      guestOptionsById.get(networkGuestId)?.label ||
      (typeof fallbackLabel === "function"
        ? fallbackLabel(networkGuestId)
        : fallbackLabel),
  }));
};

export const toggleGuestSelection = (selectedIds = [], networkGuestId) =>
  selectedIds.includes(networkGuestId)
    ? selectedIds.filter((selectedId) => selectedId !== networkGuestId)
    : [...selectedIds, networkGuestId];
